import { useRef, useState } from 'react';

export const useProcessLinks = () => {
  const [processingLinks, setProcessingLinks] = useState<Set<string>>(
    new Set(),
  );
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const timerId = useRef<number | null>(null);

  const showTooltip = () => {
    if (timerId.current) {
      clearTimeout(timerId.current);
    }

    setIsTooltipVisible(true);
    timerId.current = window.setTimeout(() => {
      setIsTooltipVisible(false);
    }, 3000);
  };

  const closeTooltip = () => {
    setIsTooltipVisible(false);
  };

  const addProcessingLink = (link: string) => {
    setProcessingLinks((prev) => new Set(prev).add(link));
  };

  const removeProcessingLink = (link: string) => {
    setProcessingLinks((prev) => {
      const next = new Set(prev);
      next.delete(link);
      return next;
    });
  };

  return {
    processingLinks,
    addProcessingLink,
    removeProcessingLink,
    isTooltipVisible,
    showTooltip,
    closeTooltip,
  };
};
